/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Open_RecentInputs */

const en_us2_search_open_recent = /** @type {(inputs: Search_Open_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search again`)
};

const pt_br2_search_open_recent = /** @type {(inputs: Search_Open_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar de novo`)
};

const es_419_search_open_recent = /** @type {(inputs: Search_Open_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar de nuevo`)
};

const pt_pt2_search_open_recent = /** @type {(inputs: Search_Open_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar de novo`)
};

const fr_fr2_search_open_recent = /** @type {(inputs: Search_Open_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher à nouveau`)
};

const de_de2_search_open_recent = /** @type {(inputs: Search_Open_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut suchen`)
};

const it_it2_search_open_recent = /** @type {(inputs: Search_Open_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca di nuovo`)
};

/**
* | output |
* | --- |
* | "Search again" |
*
* @param {Search_Open_RecentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_open_recent = /** @type {((inputs?: Search_Open_RecentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Open_RecentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_open_recent(inputs)
	if (locale === "es-419") return es_419_search_open_recent(inputs)
	if (locale === "pt-PT") return pt_pt2_search_open_recent(inputs)
	if (locale === "fr-FR") return fr_fr2_search_open_recent(inputs)
	if (locale === "de-DE") return de_de2_search_open_recent(inputs)
	if (locale === "it-IT") return it_it2_search_open_recent(inputs)
	return en_us2_search_open_recent(inputs)
});
export { search_open_recent as "search.open_recent" }